import { Heading, Tabs, View } from "@instructure/ui";
import { t } from "i18next";
import { useState } from "react";
import AcademicYears from "./AcademicYears/AcademicYears";
import { Terms } from "./Terms/Terms";

const TermManagement = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <View as="div">
      <View as="div" borderWidth="none none small none">
        <Heading as="h2" level="h3">
          {t("termManagement.termManagement")}
        </Heading>
      </View>
      <Tabs onRequestTabChange={(_e, { index }) => setSelectedTab(index)}>
        <Tabs.Panel isSelected={selectedTab === 0} renderTitle={t("terms")}>
          <Terms />
        </Tabs.Panel>
        <Tabs.Panel
          isSelected={selectedTab === 1}
          renderTitle={t("academicYears.academicYears")}
        >
          <AcademicYears />
        </Tabs.Panel>
      </Tabs>
    </View>
  );
};

export default TermManagement;
